import { render } from "./ServiceSelector.vue?vue&type=template&id=fed77c4a&scoped=true"
import script from "./ServiceSelector.vue?vue&type=script&lang=js"
export * from "./ServiceSelector.vue?vue&type=script&lang=js"

import "./ServiceSelector.vue?vue&type=style&index=0&id=fed77c4a&lang=css"
import "./ServiceSelector.vue?vue&type=style&index=1&id=fed77c4a&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed77c4a"]])

export default __exports__